/**
 * The tones in the order the curriculum lists them: high, rising, low, falling, then the neutral
 * tone (`0`), which tone-number pinyin writes after the four full tones.
 */
export const PINYIN_TONES = [1, 2, 3, 4, 0] as const;

export type PinyinTone = (typeof PINYIN_TONES)[number];

/** What the lessons call each tone (Level 1-P1 teaches "the falling tone" with 岸 àn). */
export const PINYIN_TONE_NAMES: Readonly<Record<PinyinTone, string>> = {
  0: "Neutral",
  1: "High",
  2: "Rising",
  3: "Low",
  4: "Falling",
};

const TRAILING_TONE_DIGIT = /[0-5]$/u;

/**
 * The tone of a tone-number syllable (`ma3` → 3), with both `0` and `5` read as the neutral tone,
 * or `null` for a syllable without a tone digit.
 */
export function getPinyinTone(toneNumbersPinyin: string): PinyinTone | null {
  const digit = TRAILING_TONE_DIGIT.exec(toneNumbersPinyin.trim())?.[0];
  switch (digit) {
    case "1": {
      return 1;
    }
    case "2": {
      return 2;
    }
    case "3": {
      return 3;
    }
    case "4": {
      return 4;
    }
    case "0":
    case "5": {
      return 0;
    }
    default: {
      return null;
    }
  }
}
